"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initCreditCard = exports.setupCreditCard = exports.getCreditCardDeviceData = exports.activeBraintreeInstance = undefined;

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.tokenizeCard = tokenizeCard;
exports.threeDSecureVerifyCard = threeDSecureVerifyCard;
exports.setupPayPal = setupPayPal;
exports.initPayPal = initPayPal;

var _bluebird = require("bluebird");

var _bluebird2 = _interopRequireDefault(_bluebird);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _qs = require("qs");

var _qs2 = _interopRequireDefault(_qs);

var _underscore = require("underscore");

var _underscore2 = _interopRequireDefault(_underscore);

var _client = require("braintree-web/client");

var _dataCollector = require("braintree-web/data-collector");

var _threeDSecure = require("braintree-web/three-d-secure");

var _paypalCheckout = require("braintree-web/paypal-checkout");

var _reactAsyncScript = require("react-async-script");

var _reactAsyncScript2 = _interopRequireDefault(_reactAsyncScript);

var _config = require("../config");

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var activeBraintreeInstance = exports.activeBraintreeInstance = null;

var expirationDate = _ramda2.default.compose(_ramda2.default.join("/"), _ramda2.default.adjust(_ramda2.default.compose(_ramda2.default.join(""), _ramda2.default.prepend("20")), 1), _ramda2.default.split("/"), _ramda2.default.replace(/\s/g, ""));

function tokenizeCard(_ref) {
  var clientToken = _ref.clientToken,
      clientInstanceArg = _ref.clientInstance,
      cardNumber = _ref.cardNumber,
      cardCvc = _ref.cardCvc,
      cardExpiry = _ref.cardExpiry,
      postalCode = _ref.postalCode;

  return _bluebird2.default.try(function () {
    if (clientInstanceArg) {
      return clientInstanceArg;
    }

    return (0, _client.create)({
      authorization: clientToken
    });
  }).then(function (clientInstance) {
    return clientInstance.request({
      endpoint: "payment_methods/credit_cards",
      method: "post",
      data: {
        creditCard: {
          number: cardNumber,
          cvv: cardCvc,
          expirationDate: expirationDate(cardExpiry),
          billingAddress: {
            postalCode: postalCode && postalCode.slice(0, 10)
          },
          options: {
            validate: false
          }
        }
      }
    }).then(function (_ref2) {
      var creditCards = _ref2.creditCards;

      var _creditCards = (0, _slicedToArray3.default)(creditCards, 1),
          defaultCreditCard = _creditCards[0];

      var nonce = defaultCreditCard.nonce,
          bin = defaultCreditCard.details.bin;


      return { nonce: nonce, bin: bin };
    });
  }).catch(function (err) {
    console.log(err);
  });
}

function threeDSecureVerifyCard(_ref3) {
  var clientToken = _ref3.clientToken,
      clientInstanceArg = _ref3.clientInstance,
      nonce = _ref3.nonce,
      bin = _ref3.bin,
      amount = _ref3.amount,
      email = _ref3.email,
      address = _ref3.address,
      city = _ref3.city,
      postalCode = _ref3.postalCode,
      country = _ref3.country;

  return _bluebird2.default.try(function () {
    if (clientInstanceArg) {
      return clientInstanceArg;
    }

    return (0, _client.create)({
      authorization: clientToken
    });
  }).then(function (clientInstance) {
    return (0, _threeDSecure.create)({ client: clientInstance, version: 2 }).then(function (threeDInstance) {
      return threeDInstance.verifyCard({
        nonce: nonce,
        bin: bin,
        amount: amount,
        email: email,
        billingAddress: {
          streetAddress: address && address.replace(/[^a-zA-Z0-9]/g, "").trim().slice(0, 50), //remove special charachters, trim and slice to max 50
          locality: city && city.slice(0, 50),
          postalCode: postalCode && postalCode.slice(0, 10),
          countryCodeAlpha2: country && country.slice(0, 2)
        },

        onLookupComplete: function onLookupComplete(_, next) {
          return next();
        }
      }).then(function (_ref4) {
        var nonce = _ref4.nonce;
        return nonce;
      });
    });
  });
}

/* export function getCreditCardPaymentMethodNonces({
 *   clientToken,
 *   cardNumber,
 *   cardCvc,
 *   cardExpiry,
 *   amount,
 *   email,
 *   address,
 *   city,
 *   postalCode,
 *   country,
 * }) {
 *   return createClient({
 *     authorization: clientToken,
 *   }).then(clientInstance =>
 *     tokenizeCard({ clientInstance, cardNumber, cardCvc, cardExpiry, postalCode }).then(
 *       ({ nonce, bin }) =>
 *         threeDSecureVerifyCard({
 *           clientInstance,
 *           nonce,
 *           bin,
 *           amount,
 *           email,
 *           address,
 *           city,
 *           postalCode,
 *           country,
 *         }).then(threeDNonce =>
 *           tokenizeCard({
 *             clientInstance,
 *             cardNumber,
 *             cardCvc,
 *             cardExpiry,
 *             postalCode,
 *           }).then(({ nonce }) => ({ nonce, threeDNonce }))
 *         )
 *     )
 *   );
 * }
 *  */
var getCreditCardDeviceData = exports.getCreditCardDeviceData = function getCreditCardDeviceData(clientToken) {
  return (
    // https://braintree.github.io/braintree-web/current/module-braintree-web_data-collector.html#.create
    // @TODO properly set device data
    _bluebird2.default.resolve("123")
  );
};

function setupPayPal(_ref5) {
  var container = _ref5.container,
      singleUse = _ref5.singleUse,
      amount = _ref5.amount,
      currency = _ref5.currency,
      setDeviceData = _ref5.setDeviceData,
      setNonce = _ref5.setNonce,
      setPaypalEmail = _ref5.setPaypalEmail,
      clientToken = _ref5.clientToken,
      clientInstanceArg = _ref5.clientInstance;

  return _bluebird2.default.try(function () {
    if (clientInstanceArg) {
      return clientInstanceArg;
    }

    return (0, _client.create)({
      authorization: clientToken
    });
  }).then(function (clientInstance) {
    return (0, _paypalCheckout.create)({ client: clientInstance });
  }).then(function (paypalCheckoutInstance) {
    teardownPaypalContainer("#" + container);

    return paypalCheckoutInstance.loadPayPalSDK({
      commit: false,
      vault: !singleUse,
      "disable-funding": "credit,card,sepa,bancontact,eps,giropay,ideal,mybank,sofort"
    }).then(function () {
      // PayPal script must be loaded and exposed as a global var paypal
      // See more: https://developer.paypal.com/docs/checkout/integrate/#2-add-the-paypal-script-to-your-web-page
      return paypal.Buttons({
        style: {
          color: "blue"
        },
        createOrder: singleUse ? function () {
          return paypalCheckoutInstance.createPayment({
            flow: "checkout",

            currency: currency,
            amount: amount,

            intent: "sale",
            offerCredit: false,
            enableShippingAddress: false,
            shippingAddressEditable: false
          });
        } : undefined,
        createBillingAgreement: !singleUse ? function () {
          return paypalCheckoutInstance.createPayment({
            flow: "vault",

            currency: currency,
            amount: amount,

            intent: "sale",
            offerCredit: false,
            enableShippingAddress: false,
            shippingAddressEditable: false
          });
        } : undefined,
        onApprove: function onApprove(data) {
          return paypalCheckoutInstance.tokenizePayment(data).then(function (payload) {
            setNonce(payload.nonce);
            setPaypalEmail(payload.details.email);
          });
        },
        onError: function onError(error) {
          console.log("ERROR", error);
        }
      }).render("#" + container);
    });
  }).catch(function (err) {
    console.log(err);
    // @TODO development log
  });
}

var setupCreditCard = exports.setupCreditCard = function setupCreditCard(_ref6) {
  var setDeviceData = _ref6.setDeviceData,
      setNonce = _ref6.setNonce,
      clientToken = _ref6.clientToken;

  return new _bluebird2.default(function (resolve, reject) {
    var client = require("braintree-web/client");
    var hostedFields = require("braintree-web/hosted-fields");
    var threeDSecure = require("braintree-web/three-d-secure");

    var form = document.querySelector("#creditCardForm");

    client.create({
      authorization: clientToken
    }, function (err, clientInstance) {
      if (err) {
        console.error(err);
        reject(err);
      }
      createHostedFields(clientInstance).then(function () {
        resolve(true);
      });
    });
    function createHostedFields(clientInstance) {
      var hostedForm = hostedFields.create({
        client: clientInstance,
        styles: {
          input: {
            "font-size": "16px",
            "font-family": "courier, monospace",
            "font-weight": "lighter",
            color: "white",
            border: "2px solid white"
          },
          ":focus": {
            color: "white"
          },
          ":hover": {
            border: "2px solid white"
          },
          ".valid": {
            color: "#50ae55"
          },
          ".invalid": {
            color: "rgb(244, 66, 54)"
          }
        },
        fields: {
          number: {
            selector: "#card-number",
            placeholder: "4111 1111 1111 1111"
          },
          cvv: {
            selector: "#cvv",
            placeholder: "111"
          },
          expirationDate: {
            selector: "#expiration-date",
            placeholder: "MM/YY"
          }
        }
      }, function (err, hostedFieldsInstance) {
        if (err) {
          reject(err);
        }
        teardown().then(function () {
          // tearing down once again due to a race condition
          exports.activeBraintreeInstance = activeBraintreeInstance = hostedFieldsInstance;

          resolve(hostedFieldsInstance);
        });
        var tokenize = function tokenize(event) {
          event.preventDefault();

          hostedFieldsInstance.tokenize(function (err, payload) {
            if (err) {
              reject(err);
            }

            resolve(setNonce({ nonce: payload.nonce, bin: payload.details.bin }));
          });
        };
        form && form.addEventListener("submit", tokenize, false);
      });
      var threeDS = threeDSecure.create({
        authorization: clientToken,
        version: 2
      });

      return _bluebird2.default.all([hostedForm, threeDS]);
    }
  });
};

function initPayPal(opts) {
  return teardown().then(function () {
    return setupPayPal(opts);
  });
}
var initCreditCard = exports.initCreditCard = function initCreditCard(opts) {
  return teardown().then(function () {
    return setupCreditCard(opts);
  }).then(function () {
    return {
      type: "ms/payments/init_creditcart_success"
    };
  });
};

function teardown() {
  return new _bluebird2.default(function (resolve) {
    if (activeBraintreeInstance) {
      activeBraintreeInstance.teardown(resolve);
      exports.activeBraintreeInstance = activeBraintreeInstance = null;
    }
    resolve(true);
  });
}

function teardownPaypalContainer(containerQuery) {
  var container = document.querySelector && document.querySelector(containerQuery);
  if (container) {
    while (container.firstChild) {
      container.removeChild(container.firstChild);
    }
  }
}


//////////////////
// WEBPACK FOOTER
// ./src/utils/braintree.js
// module id = 2151
// module chunks = 0